import { render, staticRenderFns } from "./AmazeAddress.vue?vue&type=template&id=26a9afe0&scoped=true"
import script from "./AmazeAddress.vue?vue&type=script&lang=js"
export * from "./AmazeAddress.vue?vue&type=script&lang=js"
import style0 from "./AmazeAddress.vue?vue&type=style&index=0&id=26a9afe0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a9afe0",
  null
  
)

export default component.exports